import { DateTime, Duration } from "luxon";
import { RecalledValue } from "./RecalledValue";
import { RecallType } from "./RecallType";

export class TimeSpanRecalledValue extends RecalledValue {
    startTime: DateTime;

    constructor(startTime: DateTime = DateTime.utc()) {
        super();
        this.startTime = startTime;
    }

    evaluateProperty(
        mode: RecallType,
        property: string,
        parameters: string[],
    ): string | RecalledValue {
        switch (property) {
            case "code":
                return this.toCode();
            case "text":
                return this.toText();
            case "hours":
            case "hour":
                return this.getDuration().hours.toString();
            case "minutes":
            case "minute":
                return this.getDuration().minutes.toString();
            case "seconds":
            case "second":
                return this.getDuration().seconds.toString();
            default:
                return this;
        }
    }

    private getDuration(): Duration {
        const now = DateTime.utc();
        const duration = now.diff(this.startTime);
        return duration;
    }

    toCode(): string {
        return this.getDuration().seconds.toFixed(0);
    }

    toText(): string {
        const duration = this.getDuration();
        const { hours } = duration;
        const minutes = duration.minutes.toString().padStart(2, "0");
        const seconds = duration.seconds.toString().padStart(2, "0");
        return `${hours}:${minutes}:${seconds}`;
    }
}
